(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.forskoleforumCarousel = {
    attach: function (context) {

      var sliders = once('forskoleforumCarousel:firstpage', '.firstpage-glide', context);
      for (var i = 0; i < sliders.length; i++) {
        initializeGlide(sliders[i], 4, {
          1280: {
            perView: 3,
            peek: { before: 0, after: 50 },
          },
          1025: {
            perView: 2,
            peek: { before: 0, after: 200 },
          },
          767: {
            perView: 1,
            peek: { before: 0, after: 100 },
          },
          378: {
            perView: 1,
            peek: { before: 0, after: 100 },
          },
        });
      }

      var courses = once('forskoleforumCarousel:courses', '.course-glide', context);
      for (var i = 0; i < courses.length; i++) {
        initializeGlide(courses[i], 4, {
          1280: {
            perView: 3,
            peek: { before: 0, after: 50 },
          },
          1025: {
            perView: 2,
            peek: { before: 0, after: 200 },
          },
          767: {
            perView: 2,
            peek: { before: 0, after: 100 },
          },
          480: {
            perView: 1,
            peek: { before: 0, after: 100 },
          },
        });
      }

      var scientist = once('forskoleforumCarousel:scientist', '.scientist-glide', context);
      for (var j = 0; j < scientist.length; j++) {
        initializeGlide(scientist[j], 5, {
          1280: {
            perView: 4,
            peek: { before: 0, after: 0 },
          },
          1025: {
            perView: 3,
            peek: { before: 0, after: 150 },
          },
          767: {
            perView: 1,
            peek: { before: 0, after: 140 },
          },
        });
      }

      /**
       * Initierar en Glide i "slider"-läge (inte evig loop),
       * gör så att prev/next hoppar "en sida" (perView steg)
       * och döljer knappar när man inte kan gå längre.
       */
      function initializeGlide(slider, defaultPerView, breakpoints) {
        if (!slider || typeof Glide === 'undefined') return;

        var items = slider.querySelectorAll('.glide__slide');
        var minItems;

        if (window.innerWidth < 768) {
          minItems = 2; // Mobile
        } else if (window.innerWidth < 1025) {
          minItems = 3; // Tablet
        } else {
          minItems = 4; // Desktop
        }

        if (items.length < minItems) return;

        var glide = new Glide(slider, {
          type: 'slider',
          rewind: false,
          bound: true,
          perView: defaultPerView,
          gap: 32,
          peek: { before: 0, after: 0 },
          breakpoints: breakpoints,
        });

        glide.mount({ Controls: false });

        if (!slider.dataset.glidePageMoveBound) {
          slider.dataset.glidePageMoveBound = '1';
          bindPageMoveControls(slider, glide);
        }
      }

      function bindPageMoveControls(slider, glide) {
        var nextBtn = slider.querySelector('[data-glide-dir=">"]');
        var prevBtn = slider.querySelector('[data-glide-dir="<"]');

        function getRealSlidesCount() {
          return slider.querySelectorAll(
            '.glide__slides > .glide__slide:not(.glide__slide--clone)'
          ).length;
        }

        function getActivePerView() {
          var w = window.innerWidth;
          var active = glide.settings.perView;

          if (glide.settings.breakpoints) {
            var keys = Object.keys(glide.settings.breakpoints)
              .map(function (k) { return parseInt(k, 10); })
              .filter(function (n) { return !isNaN(n); })
              .sort(function (a, b) { return a - b; });

            for (var i = 0; i < keys.length; i++) {
              if (w <= keys[i]) {
                var bp = glide.settings.breakpoints[keys[i]];
                if (bp && typeof bp.perView !== 'undefined') {
                  active = bp.perView;
                }
                break;
              }
            }
          }

          return Number(active) || 1;
        }

        function clamp(n, min, max) {
          return Math.max(min, Math.min(max, n));
        }

        function getMaxStartIndex() {
          var step = getActivePerView();
          var total = getRealSlidesCount();
          return Math.max(0, total - step);
        }

        function goByPage(direction) {
          var step = getActivePerView();
          var total = getRealSlidesCount();
          if (!total) return;

          var maxStart = Math.max(0, total - step);
          var current = glide.index;
          var next = current + (direction === 'next' ? step : -step);

          next = clamp(next, 0, maxStart);
          glide.go('=' + next);
        }

        function updateControls() {
          var maxStart = getMaxStartIndex();
          var index = glide.index;

          if (prevBtn) prevBtn.classList.toggle('is-disabled', index <= 0);
          if (nextBtn) nextBtn.classList.toggle('is-disabled', index >= maxStart);
        }

        function bind(button, direction) {
          if (!button) return;
          button.addEventListener('click', function (e) {
            e.preventDefault();
            goByPage(direction);
          });
        }

        bind(nextBtn, 'next');
        bind(prevBtn, 'prev');

        glide.on(['mount.after', 'run.after', 'resize'], updateControls);
        updateControls();
      }
    },
  };
})(Drupal, once);